import {Component, computed, effect, input, OnDestroy, OnInit, Renderer2, signal} from '@angular/core';
import {TaSpinnerComponent} from '../taspinner.component/taspinner.component';
import {Subject, takeUntil} from 'rxjs';
import {LoadingService, LoadingState} from '../../../services/loading.service';
import {LoadingConfig} from '../../../util/app.types';

@Component({
  selector: 'loading-indicator',
  imports: [TaSpinnerComponent],
  templateUrl: './loading-indicator.component.html',
  styleUrl: './loading-indicator.component.scss'
})
export class LoadingIndicatorComponent implements OnInit, OnDestroy{

  private targetRect = signal<Partial<DOMRect>>({});

  isGlobal = input<boolean>(false);

  // this is just for when it's a global loading indicator in app.html
  state = signal<LoadingState>({loading: false});


  // use this if you're using this without the loading service.
  config = input<LoadingConfig | null>();

  combinedOverlayStyle = computed(() => {

    let res = {
      opacity: 0.9,
      ...this.state().overlayStyle
    };

    // will put the overlay over the target element
    if (!!this.state().targetElement){
      const rect = this.targetRect();
      return {
        position: 'fixed',
        top: rect.top ? `${rect.top}px` : undefined,
        left: rect.left ? `${rect.left}px` : undefined,
        width: rect.width ? `${rect.width}px` : undefined,
        height: rect.height ? `${rect.height}px` : undefined,
        ...res, // user overrides always win
      }
    }

    return res;
  });

  combinedMessageStyle = computed(() => {
    return {
      ...this.state().messageStyle
    }
  });


  private unsubscribeAll: Subject<void>;

  constructor(private loadingService: LoadingService, private renderer: Renderer2) {
    this.unsubscribeAll = new Subject<void>();

    effect(() => {
      const target = this.state().targetElement?.nativeElement as HTMLElement | undefined;

      if (!target) return;

      this.updateTargetRect();

    });

  }

  ngOnInit(): void {
    if (this.isGlobal()) {
      this.loadingService.loading.pipe(
        takeUntil(this.unsubscribeAll))
        .subscribe(nextState => {
          // console.log('LoadingIndicator loading: ', nextState);
          this.state.set(nextState);

          if (!!nextState.targetElement) {

          }

        });

      this.loadingService.message.pipe(takeUntil(this.unsubscribeAll)).subscribe(nextState => {
        this.state.update((currentState) => {
          currentState.message = nextState.message
          return currentState;
        });
      });
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  public onClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    return;
  }


  private updateTargetRect() {
    const target = this.state().targetElement?.nativeElement as HTMLElement | undefined;
    if (!target) return;
    this.targetRect.set(target.getBoundingClientRect());
  }

}
